import { useMemo } from 'react';
import { ItemModel } from '@leverege/ui-attributes';
export default function useDefaultRollover(value, objectType) {
  return useMemo(() => {
    if (value) {
      return value;
    }
    let nValue = ItemModel.create();
    nValue = ItemModel.addType(nValue, objectType, {
      variant: 'graph'
    });
    return nValue;
  }, [value, objectType]);
}